import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React from 'react';

var ContentEditable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ContentEditable, _React$Component);

  function ContentEditable(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ContentEditable.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var props = this.props,
        htmlEl = this.htmlEl; // Rerender if there is no element yet... (somehow?)

    if (!htmlEl) {
      return true;
    } // ...or if html really changed... (programmatically, not by user edit)


    if (nextProps.html !== htmlEl.innerHTML && nextProps.html !== props.html) {
      return true;
    }

    var optional = ['style', 'className', 'disabled', 'tagName']; // Handle additional properties

    return optional.some(function (name) {
      return props[name] !== nextProps[name];
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.htmlEl && this.props.html !== this.htmlEl.innerHTML) {
      // Perhaps React (whose VDOM gets outdated because we often prevent
      // rerendering) did not update the DOM. So we update it manually now.
      this.htmlEl.innerHTML = this.props.html;
    }
  };

  _proto.onChange = function onChange(event) {
    if (!this.htmlEl) {
      return;
    }

    var html = this.htmlEl.innerHTML;

    if (this.props.onChange && html !== this.lastHtml) {
      event.target = {
        value: html,
        instance: this
      };
      this.props.onChange(event);
    }

    this.lastHtml = html;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        tagName = _this$props.tagName,
        html = _this$props.html,
        props = _objectWithoutPropertiesLoose(_this$props, ["tagName", "html"]);

    return /*#__PURE__*/React.createElement(tagName || 'div', _objectSpread(_objectSpread({}, props), {}, {
      ref: function ref(element) {
        _this2.htmlEl = element;
      },
      onInput: this.onChange,
      contentEditable: !this.props.disabled,
      dangerouslySetInnerHTML: {
        __html: html
      }
    }));
  };

  return ContentEditable;
}(React.Component);

export { ContentEditable as default };